import { Select as AntSelect } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { ETableSize } from '@components/dimensions/typed';

const Select = styled(AntSelect)`
  && .emp-ant-select-selector .emp-ant-select-selection-item {
    color: rgba(0, 0, 0, 0.45);
  }
`;

const RootContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
`;

const options = [
  {
    value: ETableSize.AUTO,
    label: 'Auto',
  },
  {
    value: ETableSize.MEDIUM,
    label: 'Medium',
  },
  {
    value: ETableSize.LARGE,
    label: 'Large',
  },
];

interface ISizeSelector {
  value: ETableSize;
  onChange: (value) => void;
}

export const SizeSelector: React.FC<ISizeSelector> = (props) => {
  const { value, onChange } = props;
  return (
    <RootContainer>
      Size:
      <Select
        bordered={false}
        options={options}
        value={value}
        onChange={onChange}
        dropdownMatchSelectWidth={80}
      />
    </RootContainer>
  );
};
